import styled from 'styled-components';
import {
  Box,
} from 'reflexbox/styled-components';

const Card = styled(Box)`
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.05);
`;

export default Card;
